<app-header></app-header>
<div class="container-fluid bg-blog-details py-24" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col items-center justify-center md:flex-row md:justify-between ">
      <div class="text-center md:text-left md:w-1/2">
        <p class="text-5xl font-bold text-white">Enroll</p>
        <p class="pt-8 text-4xl font-bold text-white">Blog Details</p>
        <p class="text-2xl text-white pt-4">Transform Your Admissions Process with Enroll AMS</p>
        <button
          class="mt-12 px-16 py-3 text-xl bg-[#6752A9] rounded-lg text-white btn-pulse transition whitespace-nowrap duration-200"
          (click)="goTo('/contact-us')">
          Contact Us
        </button>
      </div>
      <div class="md:w-1/2">
        <img
          src="./assets/images/blogs-images/blog3.jpg"
          alt="banner-image"
          class="rounded-2xl"/>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 relative">
  <div class="container mx-auto px-4 flex flex-col md:flex-row gap-8">
    <div class="w-full md:w-2/3 overflow-y-auto">
      <div *ngFor="let blogDetail of blogDetails" class="mb-8">
        <div class="blog-details">
          <div class="mb-6">
            <img [src]="blogDetail.banner" alt="Blog Banner" class="w-full h-96 object-cover">
          </div>
          <div class="article-content">
            <h3 class="text-4xl mt-2 mb-4">{{blogDetail.heading}}</h3>
            <span [innerHTML]="blogDetail.description" class="block text-justify"></span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="fixed right-0 top-1/4 w-full md:w-1/3 max-w-lg bg-white px-8 rounded-lg h-[500px] card-container fixed-card">
      <form class="p-6 flex flex-col gap-4" [formGroup]="addEnquiryForm" (ngSubmit)="submit()">
        <div class="flex flex-col gap-4">
          <p class="text-2xl text-center">Unlock Your Success—Contact Us Now!</p>
          <div class="relative pb-2 mt-2">
            <label for="name" class="block text-lg font-medium text-gray-700 mb-1">Name</label>
            <input id="name" formControlName="name" type="text" placeholder="John Doe"
                   class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                   required>
            <small class="absolute text-red-600 text-xs italic mt-1"
                   *ngIf="submitted && addEnquiryForm.get('name').hasError('required')">
              Name field is required
            </small>
          </div>
          <div class="relative pb-2">
            <label for="email" class="block text-lg font-medium text-gray-700 mb-1">Email</label>
            <input id="email" formControlName="email" type="email" placeholder="abctestmail@gmail.com"
                   class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                   required>
            <small class="absolute text-red-600 text-xs italic mt-1"
                   *ngIf="submitted && addEnquiryForm.get('email').hasError('required')">
              Email field is required
            </small>
            <small class="absolute text-red-600 text-xs italic mt-1"
                   *ngIf="submitted && addEnquiryForm.get('email').hasError('pattern')">
              Invalid email format
            </small>
          </div>
          <div class="relative pb-2">
            <label for="contact" class="block text-lg font-medium text-gray-700 mb-1">Phone Number</label>
            <input id="contact" formControlName="contact" type="tel" placeholder="+91-7836899999"
                   class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                   required>
            <small class="absolute text-red-600 text-xs italic mt-1"
                   *ngIf="submitted && addEnquiryForm.get('contact').hasError('required')">
              Contact field is required
            </small>
          </div>
          <div class="relative pb-2">
            <label for="subject" class="block text-lg font-medium text-gray-700 mb-1">Subject</label>
            <input id="subject" formControlName="subject" type="text" placeholder="Subject"
                   class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                   required>
            <small class="absolute text-red-600 text-xs italic mt-1"
                   *ngIf="submitted && addEnquiryForm.get('subject').hasError('required')">
              Subject field is required
            </small>
          </div>
          <button type="submit"
                  class="table-header-color text-white py-3 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out">
            Get a Call Back
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="above-footer container-fluid mt-10 md:mt-20 py-12">
  <div class="container">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
